import * as React from "react";
import * as ReactDOM from "react-dom/client";
import ProvideContextComponent from "./components/ProviderContextComponent";
import { createGlobalStyle, themeProps, ThemeProvider } from "./theme";
import boxSizing from "./theme/generic/box-sizing";
import normalize from "./theme/generic/normalize";
import reset from "./theme/generic/reset";
import mention from "./theme/objects/Mention";
import emoji from "./theme/objects/Emoji";
import { HashRouter as Router } from "react-router-dom";
import { SpinnerComponent } from "./components/spinner/SpinnerComponent";
import { boogleBtn } from "./theme/objects/Buttons";
import { MessagesComponent } from "./components/message/MessagesComponent";
import { RoutesComponent } from "./components/RoutesComponent";
import { fonts } from "src/theme/settings/settings-project";
import { GoogleOAuthProvider } from "@react-oauth/google";

const GlobalStyle = createGlobalStyle`
    ${fonts}
    ${boxSizing}
    ${normalize}
    ${reset}
    ${mention}
    ${emoji}
    ${boogleBtn}

    html,
    body {
        height: 100%;
        margin: 0;
    }

    #root {
        min-height: 100%;
        display: flex;
        flex-direction: column;
    }
`;

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <Router>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID!}>
      <ProvideContextComponent>
        <ThemeProvider theme={themeProps}>
          <GlobalStyle />
          <SpinnerComponent />
          <MessagesComponent />
          <RoutesComponent />
        </ThemeProvider>
      </ProvideContextComponent>
    </GoogleOAuthProvider>
  </Router>
);
